import React from 'react';
import cn from 'clsx';
import { DownloadSimpleIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { DownloadCatalogCart } from '../gallery-catalog';
import {
  kitchenDownloadCatalogBody,
  kitchenDownloadCatalogIcon,
  kitchenDownloadCatalogImage,
  kitchenDownloadCatalogText,
  newDownloadCatalogCartBody,
  newDownloadCatalogCartText,
} from './kitchen-download-catalog-styles';

type KitchenDownloadCatalogProps = {
  elementBlock: string;
  elementName: string;
  isNewKitchen?: boolean;
};

export const KitchenDownloadCatalog: React.FC<KitchenDownloadCatalogProps> = ({
  elementBlock,
  elementName,
  isNewKitchen,
}) => (
  <DownloadCatalogCart
    elementBlock={elementBlock}
    elementName={elementName}
    elementText="Скачать каталог кухонь"
    catalogHref="https://storage.yandexcloud.net/lemanapro-ru-landings-docs/kitchen/Catalog-Delinia-ID-v1.pdf"
    linkTitle="Скачать каталог кухонь">
    <div className={cn(kitchenDownloadCatalogBody, { [newDownloadCatalogCartBody]: isNewKitchen })}>
      <DownloadSimpleIcon
        className={kitchenDownloadCatalogIcon}
        type="outline"
        size="l"
        color={isNewKitchen ? 'text-minor' : 'text-primary'}
      />
      <Typography
        className={cn(kitchenDownloadCatalogText, { [newDownloadCatalogCartText]: isNewKitchen })}
        variant="l"
        size="body_accent">
        Скачать каталог кухонь
      </Typography>
    </div>
    {!isNewKitchen && (
      <img
        alt="Изображение каталога кухонь"
        className={kitchenDownloadCatalogImage}
        src="https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen/gallery/catalog-icon.png/catalog-icon.png"
      />
    )}
  </DownloadCatalogCart>
);
